import { SimpleGrid, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';

import NavLink from '@/components/UI/Links/NavLink';

import { ProductCategoryProps } from '@/models/props/ProductCategoryProps';

interface SubcategoryTilesProps {
    subcategories: ProductCategoryProps[];
}

export const SubcategoryTiles = ({ subcategories }: SubcategoryTilesProps) => {
    const router = useRouter();
    const basePath = router.asPath.split('?')[0];

    return (
        <SimpleGrid columns={{ base: 2, md: 3, lg: 6 }} spacing={4}>
            {subcategories.map((sub) => (
                <NavLink
                    key={sub.id}
                    href={`${basePath}/${sub.slug}`.replace(/\/+/g, '/')}
                    borderWidth="1px"
                    borderColor="blue.100"
                    borderRadius="lg"
                    px={4}
                    py={4}
                    textAlign="center"
                    _hover={{
                        bg: 'blue.100',
                        textDecoration: 'none'
                    }}
                    transition="background 0.2s"
                >
                    <Text fontWeight="semibold" color="blue.main">
                        {sub.name}
                    </Text>
                </NavLink>
            ))}
        </SimpleGrid>
    );
};
